import { initialState } from './../../_app_modules/shared/table/ngrx/table.reducers';
import { as } from '@common/string-formatter/string-formatter';
import { VersionService } from './../../auth/services/version-service';
import { ApplicationInfo } from './application-info.types';
import { Injectable } from '@angular/core';
import { ReplaySubject, Observable, forkJoin, map } from 'rxjs';
import { AboutHttpService } from '@about/services/about-http.service';
import { SystemConfigurationHttpService } from '@admin/services/system-configuration-http.service';
import { MojoWellKnownNames } from '@common/constants/mojo-well-known-names';

@Injectable({
  providedIn: 'root'
})
export class ApplicationInfoService {

  private appInfo: ReplaySubject<ApplicationInfo> = new ReplaySubject<ApplicationInfo>(1);

  constructor(
    private aboutHttp: AboutHttpService,
    private systemConfigurationHttp: SystemConfigurationHttpService,
    private versionService: VersionService) {
  }

  get applicationInfo$(): Observable<ApplicationInfo> {
    return this.appInfo.asObservable();
  }

  set user(value: ApplicationInfo)
  {
      this.appInfo.next(value);
  }

  get(): Observable<ApplicationInfo> {
    return forkJoin({
      about: this.aboutHttp.getAboutDetails(MojoWellKnownNames.Products.MojoForTenants),
      sysConfig: this.systemConfigurationHttp.getSystemConfiguration(MojoWellKnownNames.Products.MojoForTenants),
      versionInfo: this.versionService.getDisplayVersion()
    }).pipe(map((value) => {
      const info = { ...value.about, ...value.sysConfig, ...{ versionNumber: value.versionInfo } };
      this.appInfo.next(info);
      return info;
    }));

  }


}
